import "./style.less";

export default function bookingInfoboxMobile() {
    return {
        restrict: "E",
        scope: { bookingPeriods: "<" },
        template: require("./template.html"),

        controller: function ($scope, $rootScope, Basket, BookingPeriods) {
            const bookingPeriods = $scope.bookingPeriods;
            $scope.totalPrice = 0;
            $scope.entriesPrice = 0;
            $scope.bookingPeriodsPrice = 0;

            $scope.location = Basket.getBookingLocation();
            $scope.activity = Basket.getBookingActivity();

            const recharge = () => {
                const prices = BookingPeriods.updatePrices(bookingPeriods);
                const uniqueEntries =
                    BookingPeriods.findUniqueEntries(bookingPeriods);
                $scope.bookingPeriodsPrice = prices.bookingPeriodsPrice;
                $scope.entriesPrice = prices.entriesPrice;
                $scope.totalPrice = prices.totalPrice;
                $scope.uniqueEntries = uniqueEntries;
            };

            // on directive load
            if (bookingPeriods) {
                recharge();
            }

            // EVENTS
            var bookingUpdateEventListener = $rootScope.$on(
                "booking-update-broadcast",
                function () {
                    recharge();
                }
            );

            $scope.$on("$destroy", bookingUpdateEventListener);
        },
    };
}
